@use 'styles/functions/rem' as *;

.bodyCell {
    color: var(--data-table-body-cell-color);
    font-size: var(--data-table-body-cell-font-size);
    padding: var(--data-table-body-cell-padding);
    vertical-align: middle;

    &:first-child {
        padding-left: var(--data-table-body-cell-padding-left);
    }
}

.bodyRow {
    border-bottom: rem(1px) solid var(--data-table-body-row-border-color);
    transition: background-color 0.1s ease;

    &.clickable {
        cursor: pointer;

        &:hover {
            background-color: var(--data-table-body-row-hover-background-color);
        }
    }

    &.selected {
        background-color: var(--data-table-body-row-selected-background-color);

        &:hover {
            background-color: var(--data-table-body-row-selected-background-color);
        }
    }

    &:last-child {
        border-bottom-style: none;
    }
}

.checkbox {
    accent-color: var(--data-table-checkbox-accent-color);
    cursor: pointer;
    height: var(--data-table-checkbox-size);
    width: var(--data-table-checkbox-size);
}

.checkboxCell {
    padding-left: var(--data-table-checkbox-cell-padding-left);
    width: var(--data-table-checkbox-cell-width);
}

.dataTable {
    background-color: var(--data-table-background-color);
    border-collapse: collapse;
    font-size: var(--data-table-font-size);
    width: 100%;
}

.header {
    background-color: var(--data-table-header-background-color);
    border-bottom: rem(1px) solid var(--data-table-header-border-color);
}

.headerCell {
    color: var(--data-table-header-cell-color);
    font-size: var(--data-table-header-cell-font-size);
    font-weight: var(--data-table-header-cell-font-weight);
    letter-spacing: var(--data-table-header-cell-letter-spacing);
    padding: var(--data-table-header-cell-padding);
    text-align: left;
    text-transform: uppercase;
    white-space: nowrap;

    &:first-child {
        padding-left: var(--data-table-header-cell-padding-left);
        width: var(--data-table-header-cell-width);
    }
}
